import React from "react";

const TabSwitchingLinks = ({ activeTab, onTabChange }) => {
  if (activeTab === "login") {
    return (
      <div className="text-center mt-4">
        <p className="text-sm text-gray-600">
          Don't have an account?{" "}
          <button
            type="button"
            className="font-medium text-red-600 hover:text-red-700"
            onClick={() => onTabChange("signup")}
          >
            Sign Up
          </button>
        </p>
      </div>
    );
  }

  return (
    <div className="text-center mt-4">
      <p className="text-sm text-gray-600">
        Already have an account?{" "}
        <button
          type="button"
          className="font-medium text-red-600 hover:text-red-700"
          onClick={() => onTabChange("login")}
        >
          Login
        </button>
      </p>
    </div>
  );
};

export default TabSwitchingLinks;
